import moment from "moment";
import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { formatDate } from "./formatDate";
import {
  GET_CLIENTS_FAILURE,
  GET_CLIENT_SUBJECT_INFO_FAILURE,
  GET_GROUPING_FAILURE,
  GET_SUBJECTS_FAILURE,
  POST_CLIENT_SUBJECT_TAG_FAILURE,
  POST_CLIENT_SUBJECT_TAG_SUCCESS,
} from "./groupings";
import { populateSortAndSearchParams } from "./helpers";
import { showModal } from "./modal";
import { clearHistory, saveInitialValues } from "./undo";
import { UPDATE_DATA, actionHandler } from "./updateData";

// ------------------------------------
// Constants
// ------------------------------------
export const LEGIS_TRACK_INT_OPEN_RECORD_START =
  "LEGIS_TRACK_INT_OPEN_RECORD_START";
export const REFRESH_LEGIS_TRACK_RECORDS = "REFRESH_LEGIS_TRACK_RECORDS";
export const UPDATE_LEGIS_TRACK_REVIEW_DATA = "UPDATE_LEGIS_TRACK_REVIEW_DATA";
export const GET_LEGIS_TRACK_QUERIES_LIST_START =
  "GET_LEGIS_TRACK_QUERIES_LIST_START";
export const GET_LEGIS_TRACK_INT_QUERY_DATA_START =
  "GET_LEGIS_TRACK_INT_QUERY_DATA_START";
export const GET_LEGIS_TRACK_INT_QUERY_DATA_SUCCESS =
  "GET_LEGIS_TRACK_INT_QUERY_DATA_SUCCESS";
export const GET_LEGIS_TRACK_INT_QUERY_DATA_FAILURE =
  "GET_LEGIS_TRACK_INT_QUERY_DATA_FAILURE";
export const GET_LEGIS_TRACK_TEAM_REVIEW_DATA_START =
  "GET_LEGIS_TRACK_TEAM_REVIEW_DATA_START";
export const GET_LEGIS_TRACK_TEAM_REVIEW_DATA_SUCCESS =
  "GET_LEGIS_TRACK_TEAM_REVIEW_DATA_SUCCESS";
export const GET_LEGIS_TRACK_TEAM_REVIEW_DATA_FAILURE =
  "GET_LEGIS_TRACK_TEAM_REVIEW_DATA_FAILURE";
export const SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_START =
  "SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_START";
export const SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_SUCCESS =
  "SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_SUCCESS";
export const SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE =
  "SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE";
export const POST_LEGIS_TRACK_DATA_START = "POST_LEGIS_TRACK_DATA_START";
export const POST_LEGIS_TRACK_DATA_SUCCESS = "POST_LEGIS_TRACK_DATA_SUCCESS";
export const POST_LEGIS_TRACK_DATA_FAILURE = "POST_LEGIS_TRACK_DATA_FAILURE";
export const PUT_LEGIS_SUMMARY_START = "PUT_LEGIS_SUMMARY_START";
export const PUT_LEGIS_SUMMARY_SUCCESS = "PUT_LEGIS_SUMMARY_SUCCESS";
export const PUT_LEGIS_SUMMARY_FAILURE = "PUT_LEGIS_SUMMARY_FAILURE";
export const PUT_CLIENT_ACTION_START = "PUT_CLIENT_ACTION_START";
export const PUT_CLIENT_ACTION_SUCCESS = "PUT_CLIENT_ACTION_SUCCESS";
export const PUT_CLIENT_ACTION_FAILURE = "PUT_CLIENT_ACTION_FAILURE";
export const PUT_CLIENT_ACTION_COMMENT_START =
  "PUT_CLIENT_ACTION_COMMENT_START";
export const PUT_CLIENT_ACTION_COMMENT_SUCCESS =
  "PUT_CLIENT_ACTION_COMMENT_SUCCESS";
export const PUT_CLIENT_ACTION_COMMENT_FAILURE =
  "PUT_CLIENT_ACTION_COMMENT_FAILURE";
export const GET_LEGIS_TRACK_BASE_START = "GET_LEGIS_TRACK_BASE_START";
export const GET_LEGIS_TRACK_BASE_SUCCESS = "GET_LEGIS_TRACK_BASE_SUCCESS";
export const GET_LEGIS_TRACK_BASE_FAILURE = "GET_LEGIS_TRACK_BASE_FAILURE";
export const GET_LEGIS_TRACK_KEYWORDS_START = "GET_LEGIS_TRACK_KEYWORDS_START";
export const GET_LEGIS_TRACK_KEYWORDS_SUCCESS =
  "GET_LEGIS_TRACK_KEYWORDS_SUCCESS";
export const GET_LEGIS_TRACK_KEYWORDS_FAILURE =
  "GET_LEGIS_TRACK_KEYWORDS_FAILURE";
export const GET_LEGIS_TRACK_CLIENT_SUBJECTS_START =
  "GET_LEGIS_TRACK_CLIENT_SUBJECTS_START";
export const GET_LEGIS_TRACK_CLIENT_SUBJECTS_SUCCESS =
  "GET_LEGIS_TRACK_CLIENT_SUBJECTS_SUCCESS";
export const GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE =
  "GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE";
export const GET_LEGIS_TRACK_LEGIS_TYPE_START =
  "GET_LEGIS_TRACK_LEGIS_TYPE_START";
export const GET_LEGIS_TRACK_LEGIS_TYPE_SUCCESS =
  "GET_LEGIS_TRACK_LEGIS_TYPE_SUCCESS";
export const GET_LEGIS_TRACK_LEGIS_TYPE_FAILURE =
  "GET_LEGIS_TRACK_LEGIS_TYPE_FAILURE";
export const GET_LEGIS_TRACK_LOAD_OPTIONS_START =
  "GET_LEGIS_TRACK_LOAD_OPTIONS_START";
export const GET_LEGIS_TRACK_LOAD_OPTIONS_FAILURE =
  "GET_LEGIS_TRACK_LOAD_OPTIONS_FAILURE";
export const CLEAR_LEGIS_TRACK_FIELD_FOR_NO_RESULTS =
  "CLEAR_LEGIS_TRACK_FIELD_FOR_NO_RESULTS";
export const RETURN_LEGIS_TRACK_INITIAL_STATE =
  "RETURN_LEGIS_TRACK_INITIAL_STATE";
export const OPEN_LEGIS_TRACK_RECORD_SUCCESS =
  "OPEN_LEGIS_TRACK_RECORD_SUCCESS";
export const SET_LEGIS_TRACK_ID_REVIEWED_START =
  "SET_LEGIS_TRACK_ID_REVIEWED_START";
export const SET_LEGIS_TRACK_ID_REVIEWED_FAILURE =
  "SET_LEGIS_TRACK_ID_REVIEWED_FAILURE";
export const SET_LEGIS_TRACK_ID_REVIEWED_SUCCESS =
  "SET_LEGIS_TRACK_ID_REVIEWED_SUCCESS";
export const GET_LEGIS_TRACK_HIGHLIGHTED_DOC_START =
  "GET_LEGIS_TRACK_HIGHLIGHTED_DOC_START";
export const GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE =
  "GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE";
export const GET_LEGIS_TRACK_HIGHLIGHTED_DOC_SUCCESS =
  "GET_LEGIS_TRACK_HIGHLIGHTED_DOC_SUCCESS";
export const GET_LEGIS_TRACK_INITIAL_DATA_START =
  "GET_LEGIS_TRACK_INITIAL_DATA_START";
export const GET_LEGIS_TRACK_INITIAL_DATA_COMPLETE =
  "GET_LEGIS_TRACK_INITIAL_DATA_COMPLETE";
export const GET_QC_KEYWORD_MISSING_START = "GET_QC_KEYWORD_MISSING_START";
export const GET_QC_KEYWORD_MISSING_SUCCESS = "GET_QC_KEYWORD_MISSING_SUCCESS";
export const GET_QC_KEYWORD_MISSING_FAILURE = "GET_QC_KEYWORD_MISSING_FAILURE";
export const GET_QC_KEYWORD_REVIEW_START = "GET_QC_KEYWORD_REVIEW_START";
export const GET_QC_KEYWORD_REVIEW_SUCCESS = "GET_QC_KEYWORD_REVIEW_SUCCESS";
export const GET_QC_KEYWORD_REVIEW_FAILURE = "GET_QC_KEYWORD_REVIEW_FAILURE";
export const GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_START =
  "GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_START";
export const GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE =
  "GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE";
export const GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_SUCCESS =
  "GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_SUCCESS";
export const SET_QC_KEYWORD_REVIEW_START = "SET_QC_KEYWORD_REVIEW_START";
export const SET_QC_KEYWORD_REVIEW_FAILURE = "SET_QC_KEYWORD_REVIEW_FAILURE";
export const SET_QC_KEYWORD_REVIEW_SUCCESS = "SET_QC_KEYWORD_REVIEW_SUCCESS";
export const DELETE_LEGIS_DOC_START = "DELETE_LEGIS_DOC_START";
export const DELETE_LEGIS_DOC_SUCCESS = "DELETE_LEGIS_DOC_SUCCESS";
export const DELETE_LEGIS_DOC_FAILURE = "DELETE_LEGIS_DOC_FAILURE";
export const ADD_LEGIS_DOC_START = "ADD_LEGIS_DOC_START";
export const ADD_LEGIS_DOC_SUCCESS = "ADD_LEGIS_DOC_SUCCESS";
export const ADD_LEGIS_DOC_FAILURE = "ADD_LEGIS_DOC_FAILURE";
export const GET_LEGIS_DOC_TYPES_START = "GET_LEGIS_DOC_TYPES_START";
export const GET_LEGIS_DOC_TYPES_FAILURE = "GET_LEGIS_DOC_TYPES_FAILURE";
export const GET_LEGIS_DOC_TYPES_SUCCESS = "GET_LEGIS_DOC_TYPES_SUCCESS";
export const DELETE_LEGIS_CLIENT_SUBJECT_TAG_START =
  "DELETE_LEGIS_CLIENT_SUBJECT_TAG_START";
export const DELETE_LEGIS_CLIENT_SUBJECT_TAG_SUCCESS =
  "DELETE_LEGIS_CLIENT_SUBJECT_TAG_SUCCESS";
export const DELETE_LEGIS_CLIENT_SUBJECT_TAG_FAILURE =
  "DELETE_LEGIS_CLIENT_SUBJECT_TAG_FAILURE";
export const PUT_LEGIS_CLIENT_SUBJECT_TAG_START =
  "PUT_LEGIS_CLIENT_SUBJECT_TAG_START";
export const PUT_LEGIS_CLIENT_SUBJECT_TAG_SUCCESS =
  "PUT_LEGIS_CLIENT_SUBJECT_TAG_SUCCESS";
export const PUT_LEGIS_CLIENT_SUBJECT_TAG_FAILURE =
  "PUT_LEGIS_CLIENT_SUBJECT_TAG_FAILURE";
export const UPDATE_SUBSCRIBE_DATE_ALL_START =
  "UPDATE_SUBSCRIBE_DATE_ALL_START";
export const UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS =
  "UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS";
export const UPDATE_SUBSCRIBE_DATE_ALL_FAILURE =
  "UPDATE_SUBSCRIBE_DATE_ALL_FAILURE";
export const GET_LEGIS_HISTORY_START = "GET_LEGIS_HISTORY_START";
export const GET_LEGIS_HISTORY_FAILURE = "GET_LEGIS_HISTORY_FAILURE";
export const GET_LEGIS_HISTORY_SUCCESS = "GET_LEGIS_HISTORY_SUCCESS";
export const PUT_LEGIS_HISTORY_START = "PUT_LEGIS_HISTORY_START";
export const PUT_LEGIS_HISTORY_SUCCESS = "PUT_LEGIS_HISTORY_SUCCESS";
export const PUT_LEGIS_HISTORY_FAILURE = "PUT_LEGIS_HISTORY_FAILURE";
export const GET_LEGIS_HISTORY_LOG_START = "GET_LEGIS_HISTORY_LOG_START";
export const GET_LEGIS_HISTORY_LOG_SUCCESS = "GET_LEGIS_HISTORY_LOG_SUCCESS";
export const GET_LEGIS_HISTORY_LOG_FAILURE = "GET_LEGIS_HISTORY_LOG_FAILURE";
export const ADD_LEGIS_MANAGMENT_COMMENT_START =
  "ADD_LEGIS_MANAGMENT_COMMENT_START";
export const ADD_LEGIS_MANAGMENT_COMMENT_SUCCESS =
  "ADD_LEGIS_MANAGMENT_COMMENT_SUCCESS";
export const ADD_LEGIS_MANAGMENT_COMMENT_FAILURE =
  "ADD_LEGIS_MANAGMENT_COMMENT_FAILURE";
export const PUT_LEGIS_MANAGEMENT_COMMENT_START =
  "PUT_LEGIS_MANAGEMENT_COMMENT_START";
export const PUT_LEGIS_MANAGEMENT_COMMENT_SUCCESS =
  "PUT_LEGIS_MANAGEMENT_COMMENT_SUCCESS";
export const PUT_LEGIS_MANAGEMENT_COMMENT_FAILURE =
  "PUT_LEGIS_MANAGEMENT_COMMENT_FAILURE";
export const GET_LEGIS_TAG_COMPARISON_START = "GET_LEGIS_TAG_COMPARISON_START";
export const GET_LEGIS_TAG_COMPARISON_FAILURE =
  "GET_LEGIS_TAG_COMPARISON_FAILURE";
export const GET_LEGIS_TAG_COMPARISON_SUCCESS =
  "GET_LEGIS_TAG_COMPARISON_SUCCESS";
export const PUT_COMPANION_BILL_REVIEW_START =
  "PUT_COMPANION_BILL_REVIEW_START";
export const PUT_COMPANION_BILL_REVIEW_SUCCESS =
  "PUT_COMPANION_BILL_REVIEW_SUCCESS";
export const PUT_COMPANION_BILL_REVIEW_FAILURE =
  "PUT_COMPANION_BILL_REVIEW_FAILURE";

const headers = {
  "Content-Type": "application/json",
};

export function getLegisTrackInternalInitialState() {
  return initialState;
}

function formatDateShort(date) {
  return date && date !== "" ? moment(date).format("MM/DD/YYYY") : "";
}

function matchReviewRows(rows) {
  return rows.map((item) => {
    return {
      textValues: {
        team: item.Team || "",
        assignedBy: item.AssignedBy || "",
        assignedDate: formatDate(item.AssignedDate),
        reviewedBy: item.ReviewedBy || "",
        reviewedDate: formatDate(item.ReviewedDate),
        type: item.FlagTypeDesc,
        flag: String(item.FlagType),
      },
      isReviewed: item.ReviewedBy !== null,
    };
  });
}

function matchRecordInfo(info) {
  const recordInfo = {
    textValues: {
      id: info.RawDataID || "",
      legisId: info.LegisId,
      introDate: formatDate(info.IntroDate),
      actionDate: formatDate(info.ActionDate),
      loadDate: formatDate(info.LoadDate),
      summary: info.Summary || "",
      rawSummaryUpdateDate: formatDate(info.RawSummaryChangedDate),
      summaryUpdateDate: formatDate(info.SummaryUpdated),
      rawSummary: info.RawSummary || "",
      year: info.Year || "",
      oldLoadDate: formatDate(info.OldLoadDate),
      recordCreated: formatDate(info.CreateDate),
      lastUpdateToRecord: formatDate(info.LastUpdateTS),
      lastUpdateUserId: info.LastUpdateId || "",
      createUserId: info.CreateUserID || "",
      carryOver: info.CarryOver_Prefiled || "",
      country: info.CountryCode || "",
      state: info.State || "",
      billType: info.BillType || "",
      billNumber: info.BillNumber || "",
      session: info.Session || "",
      companion: info.Companion || "",
      url: info.Url || "",
      sspath: info.SSPath || "",
      toolboxUrl: info.ToolboxUrl || "",
      versionUrl: info.RawDataID
        ? `https://services.statescape.com/search/billversions.aspx?rid=${info.RawDataID}`
        : "",
      history: info.History || "",
      historyUpdated: formatDate(info.HistoryUpdated),
    },
    radio: {
      summaryUpdating: info.SummaryUpdating || "",
    },
  };

  return matchSubHistoryData(recordInfo, info);
}

function matchSubHistoryData(recordInfo, info) {
  return {
    ...recordInfo,
    textValues: {
      ...recordInfo.textValues,
      supplementalHistory: info.SupplementalHistory || "",
      historyRemarks: info.HistoryRemarks || "",
      historyRemarksUpdated: formatDate(info.RemarksUpdated),
      effectiveModifiedDate: formatDate(info.EffectiveModifiedDate),
      effectiveDate: formatDateShort(info.EffectiveDate),
      publicLawNumber: info.PublicActNo || "",
    },
  };
}

function matchDocuments(documents) {
  return documents
    ? documents.map((doc) => {
        return {
          url: doc.Url,
          description: doc.Description,
          urlType: doc.Type,
          id: doc.Id,
        };
      })
    : [];
}

function matchManagementComments(managementComments) {
  return managementComments
    ? managementComments.map((managementComment) => {
        return matchManagementComment(managementComment);
      })
    : [];
}

function matchManagementComment(managementComment) {
  return {
    textValues: {
      Id: managementComment.Id || "",
      RecordId: managementComment.RecordId || "",
      DataType: managementComment.DataType || "",
      DateAdded: formatDate(managementComment.DateAdded),
      AssignedBy: managementComment.AssignedBy || "",
      Comment: managementComment.Comment || "",
      Response: managementComment.Response || "",
      ResponseBy: managementComment.ResponseBy || "",
      ResponseDate: formatDate(managementComment.ResponseDate),
      MissedBill: !!managementComment.MissedBill,
      LateTagRequest: !!managementComment.LateTagRequest,
      CommentComplete: !!managementComment.CommentComplete,
      Reviewed: !!managementComment.Reviewed,
    },
    radio: {
      TeamAssigned: managementComment.TeamAssigned || "",
    },
  };
}

function matchClientSubjectTags(clientSubjectTags, currentLegisId) {
  const clientSubjectTagsForLegisId = currentLegisId
    ? clientSubjectTags.filter(
        (clientSubjectTag) => clientSubjectTag.RecordId === currentLegisId
      )
    : clientSubjectTags;

  return clientSubjectTagsForLegisId
    ? clientSubjectTagsForLegisId.map((clientSubjectTag) => {
        return matchClientSubjectTag(clientSubjectTag);
      })
    : [];
}

function matchClientSubjectTag(clientSubjectTag) {
  return {
    SubjectId: clientSubjectTag.SubjectId,
    Client: clientSubjectTag.Client,
    Subject: clientSubjectTag.Subject,
    DataType: clientSubjectTag.DataType,
    RecordId: clientSubjectTag.RecordId,
    SubscribeDate: formatDate(clientSubjectTag.SubscribeDate),
    CreateUser: clientSubjectTag.CreateUser,
    OriginalCreateDate: formatDate(clientSubjectTag.OriginalCreateDate),
    LastUpdateDate: formatDate(clientSubjectTag.LastUpdateDate),
    LastUpdateUser: clientSubjectTag.LastUpdateUser,
    IssueId: clientSubjectTag.IssueId,
    EmailAlerts: clientSubjectTag.EmailAlerts,
    Deleted: clientSubjectTag.Deleted,
    Autoload: clientSubjectTag.Autoload,
    DeletedByAnalyst: clientSubjectTag.DeletedByAnalyst,
    CanEdit: clientSubjectTag.CanEdit,
  };
}

function matchLegisDocTypes(legisDocTypes) {
  return legisDocTypes
    ? legisDocTypes
        .filter((docType) => !docType.HideAnalystAdd)
        .map((docType) => {
          return {
            label: docType.DisplayName,
            value: docType.DocType,
          };
        })
    : [];
}

function matchNonDeletableDocTypes(legisDocTypes) {
  return legisDocTypes
    ? legisDocTypes.filter((docType) => docType.HideAnalystAdd)
    : [];
}

function matchClientActions(info) {
  return info.ClientActions
    ? info.ClientActions.map((action) => {
        return matchClientAction(action);
      })
    : [];
}

function matchClientAction(action) {
  return {
    textValues: {
      stsReviewer: action.StateScapeCheckedBy || "",
      reviewDate: formatDate(action.StateScapeCheckedDate),
      stsComment: action.StateScapeComments || "",
      client: action.Client || "",
      loginId: action.LogonId || "",
      action: action.Action || "",
      changedDate: formatDate(action.ChangeDate),
      userEmail: action.Email || "",
      actionDetails: action.ActionDetail || "",
      clientComment: action.ClientComments || "",
      clientActionId: action.ClientActionId || "",
    },
  };
}

function matchIderInfo(info) {
  return {
    textValues: {
      ider: info.IDer || "",
      iderReviewed: info.IDerReviewed || "",
      iderReviewedDate: formatDate(info.IDerReviewedDate),
    },
  };
}

function matchKeywordHits(hits) {
  return hits.map((hit) => {
    return {
      textValues: {
        team: hit.Team || "",
        client: hit.Client || "",
        grouping: hit.Subject || "",
        keyword: hit.Keyword || "",
        hits: hit.Hits,
        foundDate: formatDate(hit.FoundDate),
        changeDate: formatDate(hit.ChangeDate),
        oldHits: hit.OldHits,
        keywordId: hit.KeywordId,
        taggingInstructions: hit.GroupTaggingInstructions || "",
        description: hit.GroupDescription || "",
        overview: hit.GroupOverview || "",
        boolPhrase: hit.BoolPhrase,
        groupingId: hit.GroupingId,
      },
    };
  });
}

function matchClientSubjects(clients) {
  return clients.map((client) => {
    return {
      textValues: {
        deleted: client.DeleteIt || false,
        client: client.ClientName || "",
        clientDescription: client.ClientDescription || "",
        subject: client.Subject || "",
        subjectDescription: client.SubjectDescription || "",
        changeDate: formatDate(client.CreateDate),
        user: client.CreateUserId || "",
      },
    };
  });
}

function matchBooleansToSelectionList(values) {
  return {
    selected: Object.keys(values).filter(
      (key) => values[key] && typeof values[key] == "boolean"
    ),
  };
}

function matchQCKeywordReview(keywordsReview) {
  return keywordsReview.map((keywordReview) => {
    return {
      textValues: {
        reviewDate: formatDate(keywordReview.ReviewDate),
        reviewer: keywordReview.Reviewer || "",
        client: keywordReview.Client || "",
        subject: keywordReview.Subject || "",
      },
    };
  });
}

function matchQCKeywordMissing(keywordsMissing) {
  return keywordsMissing.map((keywordMissing) => {
    return {
      textValues: {
        client: keywordMissing.Client || "",
        subject: keywordMissing.Subject || "",
        team: keywordMissing.Team || "",
        id: keywordMissing.Id || "",
        reviewed: keywordMissing.Reviewed || "",
      },
    };
  });
}

function matchHistoryLog(historyLog) {
  return historyLog.map((log) => {
    return {
      HistoryDate: log.CreateDate,
      User: log.UserName,
      HistoryAction: log.Activity,
    };
  });
}

// ------------------------------------
// Actions
// ------------------------------------

const getReviewData = (legisId, companion) => {
  return (dispatch) =>
    dispatch(getLegisTrackBase(legisId, companion, dispatch)).then(
      (recordInfo) => {
        const rawFileId = recordInfo.textValues.id;
        Promise.all([
          dispatch(getLegisKeywords(rawFileId)),
          dispatch(getLegisClientSubjects(rawFileId)),
          dispatch(getLegistrackinthistory(legisId)),
          dispatch(getLegisHistoryLog(legisId)),
        ]);
      }
    );
};

export function openReviewRecord(legisId, companion) {
  return (dispatch) => {
    dispatch({ type: LEGIS_TRACK_INT_OPEN_RECORD_START });
    dispatch(getReviewData(legisId, companion, dispatch)).finally(() => {
      dispatch({
        type: OPEN_LEGIS_TRACK_RECORD_SUCCESS,
        payload: { legisId },
      });
    });
  };
}

const getInitialData = () => {
  return (dispatch) =>
    Promise.all([
      dispatch(getLegisTrackInternalQueryData()),
      dispatch(getLegisDocTypes()),
    ]);
};

export function loadInitialData() {
  return (dispatch) =>
    Promise.all([
      dispatch({ type: GET_LEGIS_TRACK_INITIAL_DATA_START }),
      dispatch(getInitialData()).finally(() => {
        dispatch({ type: GET_LEGIS_TRACK_INITIAL_DATA_COMPLETE });
      }),
    ]);
}

export function getLegisTrackInternalQueryData() {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_INT_QUERY_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/legistrackint`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TRACK_INT_QUERY_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TRACK_INT_QUERY_DATA_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_LEGIS_TRACK_INT_QUERY_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postLegisTrackInternal(legisUrlsParameters) {
  return (dispatch) => {
    dispatch({ type: POST_LEGIS_TRACK_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(legisUrlsParameters),
    };
    return fetch(`${globals.apiUrl}/LegisTrackInt`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_LEGIS_TRACK_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_LEGIS_TRACK_DATA_SUCCESS,
            payload: {
              json,
            },
          });
          if (json.length > 0) {
            dispatch(openReviewRecord(json[0]));
          } else {
            dispatch(showModal("No-results"));
            dispatch(clearFormFields());
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_LEGIS_TRACK_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putLegisSummary(summaryData) {
  return (dispatch) => {
    dispatch({ type: PUT_LEGIS_SUMMARY_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(summaryData),
    };
    return fetch(`${globals.apiUrl}/legissummary`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LEGIS_SUMMARY_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LEGIS_SUMMARY_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LEGIS_SUMMARY_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientAction(clientAction) {
  return (dispatch) => {
    dispatch({ type: PUT_CLIENT_ACTION_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(clientAction),
    };
    return fetch(`${globals.apiUrl}/clientaction`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_CLIENT_ACTION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_CLIENT_ACTION_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_CLIENT_ACTION_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientActionComment(clientAction) {
  return (dispatch) => {
    dispatch({ type: PUT_CLIENT_ACTION_COMMENT_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(clientAction),
    };
    return fetch(`${globals.apiUrl}/clientactioncomment`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_CLIENT_ACTION_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_CLIENT_ACTION_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });
        }

        return json;
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_CLIENT_ACTION_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisTeamReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_TEAM_REVIEW_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/TeamReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TRACK_TEAM_REVIEW_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TRACK_TEAM_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TRACK_TEAM_REVIEW_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postLegisTeamsReview(id, teams, reviewed, flagType) {
  return (dispatch) => {
    dispatch({ type: SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        legisId: id,
        team: teams[0],
        reviewed: reviewed,
        flagType: flagType,
      }),
    };
    return fetch(`${globals.apiUrl}/RawFile/TeamReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisTrackBase(id, companion) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_BASE_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(
      `${globals.apiUrl}/LegisTrackInt/${id}${
        companion ? "?companionReview=true" : ""
      }`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LEGIS_TRACK_BASE_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          const recordInfo = matchRecordInfo(json);
          const clientActions = matchClientActions(json);
          const documents = matchDocuments(json.Documents);
          const clientSubjectTags = matchClientSubjectTags(json.ClientSubjects);
          const managementComments = matchManagementComments(
            json.ManagementComments
          );
          const companionBill = json.CompanionBill;
          const companionReviewedTeams = companionBill
            ? matchBooleansToSelectionList({
                1: json.CompanionReviewedTeamGroup1,
                2: json.CompanionReviewedTeamGroup2,
                3: json.CompanionReviewedTeamGroup3,
              })
            : matchBooleansToSelectionList({});

          dispatch({
            type: GET_LEGIS_TRACK_BASE_SUCCESS,
            payload: {
              recordInfo,
              clientActions,
              documents,
              clientSubjectTags,
              managementComments,
              companionBill,
              companionReviewedTeams,
            },
          });
          dispatch(clearHistory(pageIndex.legisTrackInternal));
          dispatch(
            saveInitialValues(pageIndex.legisTrackInternal, {
              recordInfo,
              clientActions,
              documents,
            })
          );

          return recordInfo;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LEGIS_TRACK_BASE_FAILURE, json: err.message });
      });
  };
}

export function postIdReviewed(id) {
  return (dispatch) => {
    dispatch({ type: SET_LEGIS_TRACK_ID_REVIEWED_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: id,
    };
    return fetch(`${globals.apiUrl}/RawFile/IdReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_LEGIS_TRACK_ID_REVIEWED_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LEGIS_TRACK_ID_REVIEWED_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_LEGIS_TRACK_ID_REVIEWED_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisKeywords(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_KEYWORDS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetKeywords/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LEGIS_TRACK_KEYWORDS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TRACK_KEYWORDS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LEGIS_TRACK_KEYWORDS_FAILURE, json: err.message });
      });
  };
}

export function getLegisClientSubjects(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_CLIENT_SUBJECTS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetClientSubjects/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TRACK_CLIENT_SUBJECTS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getQCKeywordReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_REVIEW_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_REVIEW_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_REVIEW_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_REVIEW_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getQCKeywordMissing(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_MISSING_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordMissing/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_MISSING_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_MISSING_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_MISSING_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getSubjectGroupList(client, subject) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/SubjectGroupList`);

    const params = {
      client,
      subject,
      searchType: "Legislation",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getHighlightedDocument(teams, keywords, path) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TRACK_HIGHLIGHTED_DOC_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/KeywordHits`);

    const params = {
      docpath: path,
      service: "legis",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    if (teams && teams.length != 0) {
      teams.forEach((team) => {
        if (String(team).length > 0) {
          url.searchParams.append("teamId", team);
        }
      });
    }

    if (keywords && keywords.length != 0) {
      keywords.forEach((keyword) =>
        url.searchParams.append("keywordId", keyword)
      );
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.url;
        } else if (response.status === 302) {
          return response.url;
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((url) => {
        if (url) {
          dispatch({
            type: GET_LEGIS_TRACK_HIGHLIGHTED_DOC_SUCCESS,
            payload: {
              url,
            },
          });
          return url;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function postQCKeywordReview(rawfileId, team, customName) {
  return (dispatch) => {
    dispatch({ type: SET_QC_KEYWORD_REVIEW_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({ rawfileId, team, customName }),
    };

    return fetch(`${globals.apiUrl}/RawFile/QCKeywordReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((success) => {
        return success;
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: err.message });
      });
  };
}

export function deleteLegisDocument(docId) {
  return (dispatch) => {
    dispatch({ type: DELETE_LEGIS_DOC_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/legisdoc/${docId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_LEGIS_DOC_SUCCESS,
            payload: {
              docId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_LEGIS_DOC_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_LEGIS_DOC_FAILURE, json: err.message });
      });
  };
}

export function addLegisDocument(document) {
  return (dispatch) => {
    dispatch({ type: ADD_LEGIS_DOC_START });

    const { type, url, description, linkedRecord } = document;

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        Type: type,
        Url: url,
        Description: description,
        RawFileId: linkedRecord,
      }),
    };

    return fetch(`${globals.apiUrl}/legisdoc`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_LEGIS_DOC_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_LEGIS_DOC_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_LEGIS_DOC_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisDocTypes() {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_DOC_TYPES_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/rawfile/getLegisDocTypes`);

    try {
      return fetch(url, options)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            dispatch(logOut());
          } else if (response.status === 400) {
            response.text().then((text) => {
              if (text) {
                dispatch({
                  type: GET_LEGIS_DOC_TYPES_FAILURE,
                  json: text,
                });
                dispatch(showModal("Error"));
              }
            });
          }
        })
        .then((json) => {
          if (json) {
            dispatch({
              type: GET_LEGIS_DOC_TYPES_SUCCESS,
              payload: {
                json,
              },
            });
            return json;
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch({
            type: GET_LEGIS_DOC_TYPES_FAILURE,
            json: "Highlighting document: " + err.message,
          });
          dispatch(showModal("Error"));
        });
    } catch {
      (error) => {
        dispatch({
          type: GET_LEGIS_DOC_TYPES_FAILURE,
          json: error,
        });
      };
    }
  };
}

export function deleteClientSubjectTag(subjectId) {
  return (dispatch) => {
    dispatch({ type: DELETE_LEGIS_CLIENT_SUBJECT_TAG_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/clientSubjectTag/${subjectId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_LEGIS_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              subjectId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: DELETE_LEGIS_CLIENT_SUBJECT_TAG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: DELETE_LEGIS_CLIENT_SUBJECT_TAG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientSubjectTag(clientSubjectTag) {
  return (dispatch) => {
    dispatch({ type: PUT_LEGIS_CLIENT_SUBJECT_TAG_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(clientSubjectTag)],
    };
    return fetch(`${globals.apiUrl}/clientSubjectTag`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LEGIS_CLIENT_SUBJECT_TAG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LEGIS_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              json,
            },
          });
        }

        return json;
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LEGIS_CLIENT_SUBJECT_TAG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateSubscribeDateForAll(recordId, dataType, subscribeDate) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SUBSCRIBE_DATE_ALL_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({
        recordId,
        dataType,
        subscribeDate,
      }),
    };
    return fetch(`${globals.apiUrl}/ClientSubjectSubscription`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: UPDATE_SUBSCRIBE_DATE_ALL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS,
            payload: {
              json,
            },
          });
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: UPDATE_SUBSCRIBE_DATE_ALL_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegistrackinthistory(legisId) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_HISTORY_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/legistrackinthistory/${legisId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_HISTORY_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_HISTORY_SUCCESS,
            payload: {
              json,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_HISTORY_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function putLegisHistory(historyData) {
  return (dispatch) => {
    dispatch({ type: PUT_LEGIS_HISTORY_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(historyData),
    };

    return fetch(`${globals.apiUrl}/legistrackinthistory`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LEGIS_HISTORY_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LEGIS_HISTORY_SUCCESS,
            payload: {
              json,
            },
          });
        }

        return json;
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LEGIS_HISTORY_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisHistoryLog(id) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_HISTORY_LOG_START });
    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/HistoryLog`);

    const params = {
      entityType: 5,
      entityId: id,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LEGIS_HISTORY_LOG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_HISTORY_LOG_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LEGIS_HISTORY_LOG_FAILURE, json: err.message });
      });
  };
}

export function addManagementComment(
  recordId,
  team,
  comment,
  lateTagRequest,
  missedBill
) {
  return (dispatch) => {
    dispatch({ type: ADD_LEGIS_MANAGMENT_COMMENT_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        recordId,
        DataType: "legis",
        TeamAssigned: team,
        comment,
        lateTagRequest,
        missedBill,
      }),
    };

    return fetch(`${globals.apiUrl}/managementcomments`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_LEGIS_MANAGMENT_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_LEGIS_MANAGMENT_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_LEGIS_MANAGMENT_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateManagementComment(managementComment) {
  return (dispatch) => {
    dispatch({ type: PUT_LEGIS_MANAGEMENT_COMMENT_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(managementComment),
    };

    return fetch(`${globals.apiUrl}/managementcomments`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LEGIS_MANAGEMENT_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LEGIS_MANAGEMENT_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });
        }

        return json;
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LEGIS_MANAGEMENT_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLegisTagComparison(primaryLegisId, companionLegisId) {
  return (dispatch) => {
    dispatch({ type: GET_LEGIS_TAG_COMPARISON_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/LegisTagComparison`);

    const params = {
      primaryLegisId,
      companionLegisId,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGIS_TAG_COMPARISON_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGIS_TAG_COMPARISON_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGIS_TAG_COMPARISON_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putCompanionBillReview(legisId, team, reviewed) {
  return (dispatch) => {
    dispatch({ type: PUT_COMPANION_BILL_REVIEW_START });

    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({
        LegisId: legisId,
        Reviews: [{ TeamGroupId: team, Reviewed: reviewed }],
      }),
    };

    return fetch(`${globals.apiUrl}/CompanionBillReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_COMPANION_BILL_REVIEW_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_COMPANION_BILL_REVIEW_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_COMPANION_BILL_REVIEW_FAILURE,
          json: err.message,
        });
      });
  };
}

export function clearFormFields() {
  return {
    type: CLEAR_LEGIS_TRACK_FIELD_FOR_NO_RESULTS,
  };
}

export function returnInitialState() {
  return {
    type: RETURN_LEGIS_TRACK_INITIAL_STATE,
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.legisTrackInternal
      ? state
      : actionHandler(state, action),
  [RETURN_LEGIS_TRACK_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_LEGIS_TRACK_INT_QUERY_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_TRACK_INT_QUERY_DATA_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queriesWithParameters: json,
        queries: json.map((item) => {
          return {
            value: item.QueryId,
            label: item.QueryName,
          };
        }),
      },
    };
  },
  [PUT_LEGIS_SUMMARY_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LEGIS_SUMMARY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LEGIS_SUMMARY_SUCCESS]: (state, action) => {
    const info = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          recordInfo: {
            ...state.formDataValue.LTI.recordInfo,
            textValues: {
              ...state.formDataValue.LTI.recordInfo.textValues,
              summary: info.Summary || "",
              summaryUpdateDate: formatDate(info.SummaryUpdated),
            },
            radio: {
              ...state.formDataValue.LTI.recordInfo.radio,
              summaryUpdating: info.SummaryView || "",
            },
          },
        },
      },
    };
  },
  [PUT_LEGIS_HISTORY_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LEGIS_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LEGIS_HISTORY_SUCCESS]: (state, action) => {
    const info = action.payload.json;
    const currentLegisProgress = matchBooleansToSelectionList(info);
    const newState = {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          currentLegisProgress: currentLegisProgress,
          recordInfo: matchSubHistoryData(
            state.formDataValue.LTI.recordInfo,
            info
          ),
        },
      },
    };

    return newState;
  },
  [PUT_LEGIS_MANAGEMENT_COMMENT_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LEGIS_MANAGEMENT_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LEGIS_MANAGEMENT_COMMENT_SUCCESS]: (state, action) => {
    const newManagementComment = action.payload.json;

    const commentIndex = state.formDataValue.LTI.managementComments.findIndex(
      (managementComment) =>
        managementComment.textValues.Id === newManagementComment.Id
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          managementComments: Object.assign(
            [],
            state.formDataValue.LTI.managementComments,
            {
              [commentIndex]: matchManagementComment(newManagementComment),
            }
          ),
        },
      },
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS]: (state, action) => {
    const clientSubjectTags = matchClientSubjectTags(action.payload.json);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          clientSubjectTags,
        },
      },
    };
  },
  [PUT_LEGIS_CLIENT_SUBJECT_TAG_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LEGIS_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LEGIS_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const newCientSubjectTag = action.payload.json;

    const tageIndex = state.formDataValue.LTI.clientSubjectTags.findIndex(
      (clientSubjectTag) =>
        clientSubjectTag.SubjectId === newCientSubjectTag.SubjectId
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          clientSubjectTags: Object.assign(
            [],
            state.formDataValue.LTI.clientSubjectTags,
            {
              [tageIndex]: matchClientSubjectTag(newCientSubjectTag),
            }
          ),
        },
      },
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_SUCCESS]: (state, action) => {
    return clientAtionSuccess(action, state);
  },
  [PUT_CLIENT_ACTION_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_CLIENT_ACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_CLIENT_ACTION_SUCCESS]: (state, action) => {
    return clientAtionSuccess(action, state);
  },
  [PUT_COMPANION_BILL_REVIEW_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_COMPANION_BILL_REVIEW_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_COMPANION_BILL_REVIEW_SUCCESS]: (state, action) => {
    const companionBill = action.payload.json;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          companionReviewedTeams: companionBill
            ? matchBooleansToSelectionList({
                1: companionBill.CompanionReviewedTeamGroup1,
                2: companionBill.CompanionReviewedTeamGroup2,
                3: companionBill.CompanionReviewedTeamGroup3,
              })
            : matchBooleansToSelectionList({}),
        },
      },
    };
  },
  [POST_LEGIS_TRACK_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [POST_LEGIS_TRACK_DATA_SUCCESS]: (state, action) => {
    const queryRecords = action.payload.json;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queryRecords,
      },
    };
  },
  [POST_LEGIS_TRACK_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_LEGIS_TRACK_TEAM_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_TRACK_TEAM_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [GET_LEGIS_TRACK_TEAM_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [SET_LEGIS_TRACK_TEAMS_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LEGIS_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_LEGIS_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LEGIS_DOC_SUCCESS]: (state, action) => {
    const { docId } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          documents: state.formDataValue.LTI.documents.filter(
            (doc) => doc.id !== docId
          ),
        },
      },
    };
  },
  [DELETE_LEGIS_CLIENT_SUBJECT_TAG_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_LEGIS_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LEGIS_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const { subjectId } = action.payload;
    const newClientSubjectTags = [...state.formDataValue.LTI.clientSubjectTags];
    const changingClientSubjectTag = newClientSubjectTags.find(
      (clientSubjectTag) => clientSubjectTag.SubjectId === subjectId
    );

    changingClientSubjectTag.Deleted = true;
    changingClientSubjectTag.DeletedByAnalyst = true;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          clientSubjectTags: newClientSubjectTags,
        },
      },
    };
  },
  [ADD_LEGIS_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_LEGIS_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_LEGIS_DOC_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const newDocument = matchDocuments([json]);
    const newDocuments = [...state.formDataValue.LTI.documents, ...newDocument];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          documents: newDocuments,
        },
      },
    };
  },
  [ADD_LEGIS_MANAGMENT_COMMENT_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_LEGIS_MANAGMENT_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_LEGIS_MANAGMENT_COMMENT_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const newManagamentComment = matchManagementComment(json);
    const newManagamentComments = [
      newManagamentComment,
      ...state.formDataValue.LTI.managementComments,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          managementComments: newManagamentComments,
        },
      },
    };
  },
  [GET_LEGIS_TRACK_QUERIES_LIST_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_TRACK_BASE_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_TRACK_BASE_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LEGIS_TRACK_BASE_SUCCESS]: (state, action) => {
    const clientActions = action.payload.clientActions;
    const recordInfo = action.payload.recordInfo;
    const documents = action.payload.documents;
    const clientSubjectTags = action.payload.clientSubjectTags;
    const managementComments = action.payload.managementComments;
    const companionReviewedTeams = action.payload.companionReviewedTeams;
    const companionBill = action.payload.companionBill;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          recordInfo,
          clientActions,
          documents,
          clientSubjectTags,
          managementComments,
          companionReviewedTeams,
          companionBill,
        },
      },
    };
  },
  [GET_LEGIS_TRACK_INITIAL_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_TRACK_INITIAL_DATA_COMPLETE]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [LEGIS_TRACK_INT_OPEN_RECORD_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [OPEN_LEGIS_TRACK_RECORD_SUCCESS]: (state, action) => {
    const currentIndex = state.renderData.queryRecords.findIndex(
      (record) => record === action.payload.legisId
    );
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          currentLegisId: action.payload.legisId,
          navigation: {
            ...state.formDataValue.LTI.navigation,
            textValues: {
              ...state.formDataValue.LTI.navigation.textValues,
              currentRecord: currentIndex + 1,
            },
          },
        },
      },
    };
  },
  [SET_LEGIS_TRACK_ID_REVIEWED_SUCCESS]: (state, action) => {
    const iderInfo = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          iderReviewedInfo: matchIderInfo(iderInfo),
        },
      },
    };
  },
  [GET_LEGIS_TRACK_KEYWORDS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          recordKeywordHits: matchKeywordHits(keywordHits),
        },
      },
    };
  },
  [GET_LEGIS_TRACK_CLIENT_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LEGIS_TRACK_CLIENT_SUBJECTS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          recordClientSubjects: matchClientSubjects(keywordHits),
        },
      },
    };
  },
  [GET_LEGIS_HISTORY_LOG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LEGIS_HISTORY_LOG_SUCCESS]: (state, action) => {
    const historyLog = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          textBlocks: {
            ...state.formDataValue.LTI.textBlocks,
            textValues: {
              ...state.formDataValue.LTI.textBlocks.textValues,
              log: matchHistoryLog(historyLog),
            },
          },
        },
      },
    };
  },
  [GET_QC_KEYWORD_MISSING_SUCCESS]: (state, action) => {
    const keywordsMissing = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          recordQCKeywordMissing: matchQCKeywordMissing(keywordsMissing),
        },
      },
    };
  },
  [GET_QC_KEYWORD_REVIEW_SUCCESS]: (state, action) => {
    const keywordsReview = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          recordQCKeywordReview: matchQCKeywordReview(keywordsReview),
        },
      },
    };
  },
  [GET_LEGIS_TRACK_HIGHLIGHTED_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_TRACK_HIGHLIGHTED_DOC_SUCCESS]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGIS_TRACK_HIGHLIGHTED_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LEGIS_DOC_TYPES_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_DOC_TYPES_SUCCESS]: (state, action) => {
    const legisDocTypes = matchLegisDocTypes(action.payload.json);
    const nonDeletableDocTypes = matchNonDeletableDocTypes(action.payload.json);
    return {
      ...state,
      renderData: {
        ...state.renderData,
        legisDocTypes: legisDocTypes,
        nonDeletableDocTypes: nonDeletableDocTypes,
      },
    };
  },
  [GET_LEGIS_DOC_TYPES_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_LEGIS_HISTORY_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LEGIS_HISTORY_SUCCESS]: (state, action) => {
    const currentLegisProgress = matchBooleansToSelectionList(
      action.payload.json
    );
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          currentLegisProgress: currentLegisProgress,
        },
      },
    };
  },
  [GET_LEGIS_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [POST_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const clientSubjectTags = matchClientSubjectTags(
      action.payload.json,
      state.formDataValue.LTI.currentLegisId
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          clientSubjectTags: [
            ...clientSubjectTags,
            ...state.formDataValue.LTI.clientSubjectTags,
          ],
        },
      },
    };
  },
  [POST_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_START]: (state, action) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          clientSubjectGroupings: [],
        },
      },
    };
  },
  [GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_SUCCESS]: (state, action) => {
    const groupingsList = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          clientSubjectGroupings: groupingsList,
        },
      },
    };
  },
  [GET_LEGIS_TRACK_SUBJECT_GROUP_LIST_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_LEGIS_TAG_COMPARISON_START]: (state, action) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          companionPrimaryTags: {},
        },
      },
    };
  },
  [GET_LEGIS_TAG_COMPARISON_SUCCESS]: (state, action) => {
    const companionPrimaryTags = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LTI: {
          ...state.formDataValue.LTI,
          companionPrimaryTags: companionPrimaryTags,
        },
      },
    };
  },
  [GET_LEGIS_TAG_COMPARISON_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [SET_QC_KEYWORD_REVIEW_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_QC_KEYWORD_REVIEW_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_CLIENTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_CLIENT_SUBJECT_INFO_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [CLEAR_LEGIS_TRACK_FIELD_FOR_NO_RESULTS]: (state) => {
    const query = state.renderData.queriesWithParameters.find(
      (query) => query.QueryId == state.formDataValue.LTI.queryLine.radio.query
    );

    const {
      parametersSectionSelectables,
      sortParameters,
      sortFields,
      sortDirections,
      filterFields,
    } = populateSortAndSearchParams(query);

    return {
      ...initialState,
      disableEditing: true,
      renderData: {
        ...initialState.renderData,
        queriesWithParameters: state.renderData.queriesWithParameters,
        queries: state.renderData.queries,
        allRegions: state.renderData.allRegions,
        regions: state.renderData.regions,
        regionsList: state.renderData.regionsList,
        legisDocTypes: state.renderData.legisDocTypes,
        nonDeletableDocTypes: state.renderData.nonDeletableDocTypes,
      },
      formDataValue: {
        LTI: {
          ...initialState.formDataValue.LTI,
          queryLine: {
            ...state.formDataValue.LTI.queryLine,
          },
          parametersSection: {
            ...state.formDataValue.LTI.parametersSection,
            radio: parametersSectionSelectables,
          },
          sortParameters: {
            radio: sortParameters,
            fields: sortFields,
          },
          sortDirections: {
            radio: sortDirections,
          },
          filterParameters: {
            fields: filterFields,
          },
        },
      },
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  renderData: {
    queryRecords: [],
    queryProperties: [],
    currentRecord: {},
    recordIndex: 0,
  },
  formDataValue: {
    LTI: {
      settingsLine: {
        radio: {
          autoAdvance: true,
          autoUrl: false,
          extraInfoExpanded: false,
          clientActionsExpanded: false,
        },
      },
      queryLine: {
        radio: {
          query: "Select Query",
        },
        textValues: {
          keywordSearch: "",
        },
        selected: [],
      },
      parametersSection: {
        textValues: {},
        dateTime: {},
        radio: [],
      },
      sortParameters: {
        radio: [],
        fields: [],
      },
      sortDirections: {
        radio: [],
      },
      filterParameters: {
        fields: [],
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },
      currentLegisProgress: matchBooleansToSelectionList({}),
      reviewRecords: matchReviewRows([]),
      recordInfo: matchRecordInfo({}),
      iderReviewedInfo: matchIderInfo({}),
      recordKeywordHits: matchKeywordHits([]),
      recordClientSubjects: matchClientSubjects([]),
      recordQCKeywordMissing: matchQCKeywordMissing([]),
      recordQCKeywordReview: matchQCKeywordReview([]),
      documents: matchDocuments([]),
      clientActions: matchClientActions([]),
      clientSubjectTags: [],
      clientSubjectGroupings: [],
      managementComments: [],
      companionReviewedTeams: matchBooleansToSelectionList({}),
      companionBill: {},
      companionPrimaryTags: {
        PrimaryBill: { ClientSubjects: [] },
        CompanionBill: { ClientSubjects: [] },
      },
      otherDocs: {
        0: {
          textValues: {
            urlIdDocs: "",
            urlDescription: "",
          },
          radio: {
            docsType: "versions",
          },
        },
      },
      clients: {
        selected: [],
      },
      notLoadedClients: {
        selected: [],
      },
      history: {
        textValues: {
          history: "",
        },
      },
      textBlocks: {
        textValues: {
          log: [],
        },
      },
    },
  },
};

function clientAtionSuccess(action, state) {
  const updatedClientAction = action.payload.json;
  const clientActionIndex = state.formDataValue.LTI.clientActions.findIndex(
    (clientAction) =>
      clientAction.textValues.clientActionId ===
      updatedClientAction.ClientActionId
  );

  return {
    ...state,
    formDataValue: {
      ...state.formDataValue,
      LTI: {
        ...state.formDataValue.LTI,
        clientActions: Object.values({
          ...state.formDataValue.LTI.clientActions,
          [clientActionIndex]: matchClientAction(updatedClientAction),
        }),
      },
    },
  };
}

export default function legisTrackInternalReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/legisTrackInternalFormData.js